import React from 'react'
import Header from '../components/Header/Header';
import Body from '../components/Body/Body';
import Footer from '../components/Footer/Footer';


const Home = () => {
  return (
    <>
    
    <Header id='windowclose' />
    <Body />
    <Footer />
    </>
  )
}

export default Home;